import { arrayOf, number, object, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { GumletImage } from './impl/gumlet-image';
import { ThumborImage } from './impl/thumbor-image';

function mapStateToProps(state) {
  return {
    imageCDN: state.qt.config['cdn-image'],
    imageCDNFormat: state.qt.config['image-cdn-format'] || 'thumbor'
  };
}

function ResponsiveImageBase(props) {
  if (process.env.NODE_ENV == 'development' && !props.alt && !props.reactTag) {
    global.console && global.console.warn("Image Found without an alt attribute: ".concat(props.slug));
  }

  if (props.imageCDNFormat === 'gumlet') {
    return /*#__PURE__*/React.createElement(GumletImage, props);
  }

  return /*#__PURE__*/React.createElement(ThumborImage, props);
}

/**
 * This component takes an image, and resizes it to the correct aspect ratio using imgix or thumbor.
 *
 * See the tutorial {@tutorial using-responsive-image} for an in depth look at using this component
 *
 * Example
 * ```javascript
 * import { ResponsiveImage } from '@quintype/components';
 *
 * <figure className="story-grid-item-image qt-image-16x9">
 *   <ResponsiveImage slug={props.story["hero-image-s3-key"]}
 *     metadata={props.story["hero-image-metadata"]}
 *     alt={props.story['headline']}
 *     aspectRatio={[16,9]}
 *     defaultWidth={480} widths={[250,480,640]}
 *     sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 23vw"
 *     imgParams={{auto:['format', 'compress']}}/>
 * </figure>
 * ```
 * @component
 * @category Images
 * @tutorial using-responsive-image
 */
export var ResponsiveImage = /*#__PURE__*/connect(mapStateToProps, {})(ResponsiveImageBase);